// src/App.js
import React from 'react';
import { BrowserRouter as Router, Route, Routes } from 'react-router-dom';
import { BookProvider } from './contexts/BookContext';

import ErrorBoundary from './components/ErrorBoundary';
import Home from './pages/Home/Home';
import BookDetail from './pages/BookDetail/BookDetail';

const App = () => (
    <ErrorBoundary>
      <BookProvider>
        <Router>
          <Routes>
            <Route path="/" element={<Home />} />
            <Route path="/book/:id" element={<BookDetail />} />
          </Routes>
        </Router>
      </BookProvider>
    </ErrorBoundary>
  );
  
  export default App;
